import * as React from "react";
import { INavigationComponent } from "src/ScrollyInterface";
import "./Navigation.scss";

class Navigation extends React.Component<INavigationComponent> {
  public generateNavigation = () => {
    const { contentId, navImages, navType, onNavigationClicked } = this.props;
    return navImages.map((navImage: string, index: number) => {
      const style =
        contentId === index
          ? {
              borderRadius: "100%",
              height: "12px",
              margin: "-6px 0 0 -6px",
              width: "12px"
            }
          : {};

      return (
        <li
          className={`Navigation-item-${navType}`}
          key={index}
          onClick={onNavigationClicked.bind(this, index)}
        >
          {navType === "desktop" ? (
            <a className={`Navigation-link-${navType}`}>
              <span className={`Navigation-content-${navType}`} style={style} />
            </a>
          ) : (
            <a className={`Navigation-link-${navType}`}>
              <img
                className={`Navigation-content-${navType}`}
                src={navImages[index]}
              />
            </a>
          )}
        </li>
      );
    });
  };

  public render() {
    const { navType } = this.props;
    return (
      <div className={`Navigation-container-${navType}`}>
        <nav className={`Navigation-${navType}`}>
          <ul className={`Navigation-menu-${navType}`}>
            {this.generateNavigation()}
          </ul>
        </nav>
      </div>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.tsx